import {
    getUniqFieldId,
} from 'app/common/DomainObject'
import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

const config: SkyNetTableConfig<DailyOpsFields> = {
    tabs: [{
        name: 'Pick-up Via Road: Confirmation',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'from',
                filterField: 'from',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'to',
                filterField: 'to',
                filterType: FilterType.Array,
                width: '100px',
            },
            {
                name: 'customerLocationName',
                filterField: 'customerLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                filterField: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
                filterType: FilterType.Array,
            },
            {
                name: 'mawbNumber',
                filterField: 'mawbNumber',
                filterType: FilterType.Array,
            },
            {
                name: 'requestedHandover',
                filterField: 'requestedHandover',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requestedHandover',
                id: getUniqFieldId('requestedHandover', 1),
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Requested Handover In',
                },
                sorting: false,
            },
        ],
    }],
}

export default config
